/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Business_DescriptionInputs */

const en_meta_business_description = /** @type {(inputs: Meta_Business_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transform how your team consumes research with AI-powered text-to-speech. Team management, centralized billing, SSO, and priority support for organizations.`)
};

const es_meta_business_description = /** @type {(inputs: Meta_Business_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transforma cómo tu equipo consume investigación con texto a voz impulsado por IA. Gestión de equipos, facturación centralizada, SSO y soporte prioritario para organizaciones.`)
};

/**
* | output |
* | --- |
* | "Transform how your team consumes research with AI-powered text-to-speech. Team management, centralized billing, SSO, and priority support for organizations." |
*
* @param {Meta_Business_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const meta_business_description = /** @type {((inputs?: Meta_Business_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Business_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_meta_business_description(inputs)
	return en_meta_business_description(inputs)
});